.shoppingCartPaper {
	position: relative;
	height: 100wh !important;
	max-width: 500px !important;
	margin-left: auto !important;
	margin-right: auto !important;
}

.cartItemsPaper {
	max-width: 460px !important;
	min-width: 460px !important;
	margin-left: -25px !important;
	margin-top: 5px !important;
	padding-top: 20px !important;
	padding-bottom: 20px !important;
	padding-left: 10px !important;
	padding-right: 10px !important;
	max-height: 300px !important;
	min-height: 300px !important;
}

.seperatorLineBottom {
	margin-bottom: 20px !important;
}

.cartItemTitle {
	max-width: 410px !important;
	min-width: 410px !important;
	margin-left: -25px !important;
}

.justifyContentCenter {
	justify-content: center !important;
}

.justifyContentEnd {
	width: 100% !important;
	justify-content: end !important;
}

.topMargin {
	margin-top: 20px !important;
}

.iButtonRemove {
	display: inline-flex !important;
	position: absolute !important;
	right: 30px !important;
	margin-top: -15px !important;
}

.iconCircle {
	border-radius: 50% !important;
}

.cartItemContainer {
	min-height: 350px !important;
	max-height: 350px !important;
	width: 100% !important;
	overflow-y: scroll !important;
	overflow-x: hidden !important;
	padding: 5px !important;
}

.topMarginFive {
	margin-top: 5px !important;
}

.topMarginTen {
	margin-top: 10px !important;
}

.minWidthUnset {
	min-width: unset !important;
}

.boldFont {
	font-weight: bold !important;
}

.discountStyleLabel {
	margin-top: -5px !important;
	padding-left: 20px !important;
	font-weight: bold !important;
	font-size: 18px !important;
}

.kdvStyleLabel {
	margin-top: -20px !important;
	padding-left: 20px !important;
	font-weight: bold !important;
	font-size: 18px !important;
}

.totalPriceStyleLabel {
	margin-top: 5px !important;
	padding-left: 20px !important;
	font-weight: bold !important;
	font-size: 18px !important;
	color: red !important;
}

.typography {
	white-space: pre-line !important;
}

@media (max-width: 540px) {
	.discountStyleLabel {
		font-size: 15px !important;
		margin-top: 30px !important;
	}
	.kdvStyleLabel {
		font-size: 15px !important;
	}
	.totalPriceStyleLabel {
		font-size: 15px !important;
	}
}
